import * as React from "react";
import { CategorizedPageHelpRegistration, RenderRegistrationCardProps } from "../../../Registry/pageHelpRegistry";
import pageIds from "pageIds";
import { CommonConfigurationTeamOverview, CommonConfigurationTeamTopics } from "../../CommonComponents/CommonConfigurationTeamViews";

export const ConfigurationTeamRegistration: CategorizedPageHelpRegistration = {
    page: pageIds.configuration.team,
    renderOverview: (renderProps: RenderRegistrationCardProps) => {
        return <CommonConfigurationTeamOverview />;
    },
    renderTopics: (renderProps: RenderRegistrationCardProps) => {
        return <CommonConfigurationTeamTopics />;
    },
};
